import { render, staticRenderFns } from "./ComplaintFollowUpChangeActivationType.vue?vue&type=template&id=15c12812&"
import script from "./ComplaintFollowUpChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports